export default {
    headerCreate: 'Add Holiday',
    headerEdit: 'Edit Holiday',
    holidayName: 'Special holiday Name',
    enterHolidayName: 'Enter Holiday Name',
    holiday: 'Holiday Date',
    save: 'save',
    require: 'this field is required.',
    congratulation: 'Congratulation',
    created: 'Holiday was created.',
    updated: 'Holiday was edited.',
    errorTitle: 'Something went wrong'
}
